var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-2"},[_c('b-spinner',{staticClass:"align-middle mr-2",attrs:{"variant":"secondary"}}),_c('strong',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.$t('components.loadingSpinner.loading')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }